import * as React from 'react';
import Button from '../button/Button';
const PickerButton = (props) => (React.createElement(Button, { size: "small", type: "primary", ...props }));
export default PickerButton;
